import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";

import galleryImg1 from "../../assets/images/gallery/galleryImg1.jpeg";
import galleryImg2 from "../../assets/images/gallery/galleryImg2.jpeg";
import galleryImg3 from "../../assets/images/gallery/galleryImg3.jpeg";
import galleryImg4 from "../../assets/images/gallery/galleryImg4.jpeg";
import galleryImg5 from "../../assets/images/gallery/galleryImg5.jpeg";
import galleryImg6 from "../../assets/images/gallery/galleryImg6.jpeg";
import galleryImg19 from "../../assets/images/gallery/galleryImg19.jpeg";
import galleryImg20 from "../../assets/images/gallery/galleryImg20.jpeg";
import galleryImg21 from "../../assets/images/gallery/galleryImg21.jpeg";
import galleryImg22 from "../../assets/images/gallery/galleryImg22.jpeg";
import heroImage from "../../assets/images/hero-image-12.jpg";

const imagesCol1 = [
  galleryImg1,
  galleryImg2,
  galleryImg3,
  galleryImg4,
  galleryImg5,
];

const imagesCol2 = [
  galleryImg6,
  galleryImg19,
  galleryImg20,
  galleryImg21,
  galleryImg22,
];

const textItem = {
  hidden: { opacity: 0, y: 30, filter: "blur(10px)" },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

/* ============================
   INFINITE TICKER COLUMN
============================ */
function InfiniteTickerColumn({ images, duration = 24, direction = "up" }) {
  const trackRef = useRef(null);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    if (trackRef.current) {
      setOffset(trackRef.current.scrollHeight / 2);
    }
  }, []);

  return (
    <div className="relative w-1/2 overflow-hidden">
      <motion.div
        ref={trackRef}
        className="absolute top-0 left-0 w-full flex flex-col gap-4"
        animate={{
          y: direction === "up" ? [0, -offset] : [-offset, 0],
        }}
        transition={{
          duration,
          ease: "linear",
          repeat: Infinity,
        }}
      >
        {[...images, ...images].map((img, i) => (
          <div
            key={i}
            className="h-[220px] rounded-[18px] overflow-hidden"
          >
            <img
              src={img}
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </motion.div>
    </div>
  );
}

export default function HeroTickerSection() {
  return (
    <header
      className="relative bg-[#0b0d10] text-white overflow-hidden"
      style={{
        backgroundImage: `url(${heroImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* DARK OVERLAY */}
      <div className="absolute inset-0 bg-[#162230]/80 z-0" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-20 items-center">

        {/* ================= RIGHT (TEXT) ================= */}
        {/* 👉 First on mobile/tablet, second on desktop */}
        <motion.div
          initial="hidden"
          animate="show"
          className="space-y-10 order-1 lg:order-2"
        >
          {/* Badge */}
          <motion.div variants={textItem}>
            <span className="inline-flex items-center gap-2 bg-white/10 px-5 py-2 rounded-full text-sm">
              Moments From The Mountains
            </span>
          </motion.div>

          {/* Heading */}
          <motion.h1
            variants={textItem}
            className="text-5xl md:text-6xl xl:text-6xl font-bold leading-tight"
          >
            Moments captured <br />
            across <br />
            <span className="text-gray-500">
              the world’s highest trails
            </span>
          </motion.h1>

          {/* Sub text */}
          <motion.p
            variants={textItem}
            className="text-xl text-gray-300 max-w-xl"
          >
            A collection of light, shadow, effort,
            and emotion captured where the world feels vast.
          </motion.p>
          {/* Buttons */}
          <motion.div
            variants={textItem}
            className="flex flex-wrap gap-3 justify-center md:justify-start"
          >
            <a
              href="/adventures/expeditions"
              className="bg-white/80 text-gray-900 px-6 py-3 rounded-full font-semibold shadow-lg hover:scale-105 transition"
            >
              See The Routes
            </a>
            <a
              href="/contact"
              className="bg-white/30 px-6 py-3 rounded-full font-semibold hover:scale-105 transition"
            >
              Start Your Journey
            </a>
          </motion.div>

        </motion.div>

        {/* ================= LEFT (TICKER) ================= */}
        {/* 👉 Below text on mobile/tablet, left on desktop */}
        <div className="relative h-[560px] lg:h-[680px] flex gap-6 overflow-hidden order-2 lg:order-1">
          <InfiniteTickerColumn
            images={imagesCol1}
            duration={22}
            direction="up"
          />
          <InfiniteTickerColumn
            images={imagesCol2}
            duration={26}
            direction="down"
          />
        </div>

      </div>
    </header>
  );
}
